module.exports = __webpack_public_path__ + "img/help.12a2c301.svg";